// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tyXx6","newExpiryDate":"styles_newExpiryDate__1Iy9H","footer":"styles_footer__3ZsUH"};